import { cn } from '@utils/cn';

import { Button } from '../Button';

export interface QuantitySelectorProps {
  quantity: number;
  maxQuantity: number;
  minQuantity: number;
  className?: string;
  onChange: (quantity: number) => void;
}

export const QuantitySelector = ({
  className,
  maxQuantity,
  minQuantity,
  onChange,
  quantity,
}: QuantitySelectorProps) => {
  return (
    <div
      className={cn(
        'flex min-h-11 items-center rounded-sm border bg-transparent px-1',
        className,
      )}
    >
      <Button
        disabled={quantity <= minQuantity}
        hideLabel
        icon="ic_minus"
        label="Decrement"
        onClick={() => onChange(quantity - 1)}
        size="xs"
        type="button"
        variant="transparent"
      />
      <span className="font-sans text-sm tabular-nums antialiased">
        {quantity}
      </span>
      <Button
        disabled={quantity >= maxQuantity}
        hideLabel
        icon="ic_add"
        label="Increment"
        onClick={() => onChange(quantity + 1)}
        size="xs"
        type="button"
        variant="transparent"
      />
    </div>
  );
};
